// extracted by mini-css-extract-plugin
export default {"fade_in":"Drinks_fade_in__hRbhe","fade-in":"Drinks_fade-in__FJ88L"};